import { useEffect, useState } from "react";
import { getQueryData } from '../../../common';
import { searchComplexAreaByPriceV4 } from "../../../repository/RealEstateRepository";
import { ComplexAreaListV2 } from "../organism";
import { DefaultPage } from "./DefaultPage";

const ComplexAreaListV2Page = (props) => {
    const [queryParams, setQueryParams] = useState(null);
    const [complexAreas, setComplexAreas] = useState([]);
    const [onLoad, setOnLoad] = useState(false);

    const getLinks = () => [
        {
            title: "Home",
            to: "/realestate"
        },
        {
            title: "ComplexAreaV2"
        }
    ];

    useEffect(() => {
        const queryParams = getQueryData(props.location.search);
        setQueryParams(queryParams);
        setTimeout(() => setOnLoad(true));
    }, [props.location]);

    useEffect(() => {
        if (queryParams == null || !queryParams.dealLeaseGap) {
            setComplexAreas([]);
            return;
        }

        searchComplexAreaByPriceV4(queryParams, (res) => setComplexAreas(res.content));
    }, [queryParams]);

    return (<>
        <DefaultPage pathname={props.location.pathname} links={getLinks()} fluid={true}>
            {onLoad && (<>
                <ComplexAreaListV2
                    history={props.history}
                    queryParams={queryParams}
                    complexAreas={complexAreas} />
            </>)}
        </DefaultPage>
    </>)
};

export { ComplexAreaListV2Page };
